"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useABContextWrapper = exports.ABContext = void 0;
const react_1 = require("react");
exports.ABContext = (0, react_1.createContext)({});
const useABContextWrapper = () => (0, react_1.useContext)(exports.ABContext);
exports.useABContextWrapper = useABContextWrapper;
//# sourceMappingURL=ABContext.js.map